module.exports = __webpack_public_path__ + "media/images/logos/discord-fd3d16dadc5daf1147b51471f70ff71a.svg";